// extracted by mini-css-extract-plugin
export var hidden = "_nw-1";
export var visible = "_nw-0";